import React from 'react';
import { Spinner } from './Spinner';
import './LoadingState.css';

interface LoadingStateProps {
  text: string;
  size?: number;
  /** `block` rellena el alto disponible; `inline` solo ocupa su padding. */
  variant?: 'block' | 'inline';
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  text,
  size = 32,
  variant = 'block'
}) => (
  <div className={`al-loading-state al-loading-state--${variant}`} role="status">
    <Spinner size={size} />
    <p className="al-loading-state-text">{text}</p>
  </div>
);
